import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../translates/translate"

/* Icons */
import { ChevronLeftIcon, ChevronRightIcon } from "./Icons"


/* Fields */
const DOTS = "..."

/* Helpers */
const range = (start, end) => {
    const length = end - start + 1
    return Array.from({ length }, (_, idx) => idx + start)
}


/*
    Component Pagination
*/
class Pagination extends Component {

    /* Build The Visible Page Numbers */
    generate = (last) => {

        /* Fields */
        const page = parseInt(this.props.page)
        const sibling = 1

        /* Every Page Fits */
        if (sibling + 5 >= last) {
            return range(1, last)
        }

        /* Window Around The Current Page */
        const left = Math.max(page - sibling, 1)
        const right = Math.min(page + sibling, last)

        /* Dots */
        const leftDots = left > 2
        const rightDots = right < last - 2

        /* Head */
        if (!leftDots && rightDots) {
            return [...range(1, 2 + 2 * sibling), DOTS, last]
        }

        /* Tail */
        if (leftDots && !rightDots) {
            return [1, DOTS, ...range(last - (2 + 2 * sibling) + 1, last)]
        }

        /* Middle */
        if (leftDots && rightDots) {
            return [1, DOTS, ...range(left, right), DOTS, last]
        }

        return []
    }

    /* Change Page */
    change = (target, last) => {

        /* Fields */
        const { page, onPageChange } = this.props

        /* Check Bounds */
        if (target < 1 || target > last || target === parseInt(page)) {
            return
        }

        /* Send */
        onPageChange(target)
    }

    /* Draw Arrow */
    _arrow = (type, last) => {

        /* Fields */
        const page = parseInt(this.props.page)

        /* Target Page */
        const target = type === "prev" ? page - 1 : page + 1

        /* Check Disabled */
        const disabled = type === "prev" ? page <= 1 : page >= last

        return (
            <div onClick={() => this.change(target, last)} className={`pagination--arrow ${disabled ? "disabled" : ""}`}>
                {type === "prev" ? <ChevronLeftIcon size={15} /> : <ChevronRightIcon size={15} />}
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { total, size, page } = this.props

        /* Check Total */
        if (!(parseInt(total) > 0) || parseInt(total) <= parseInt(size)) {
            return <div />
        }

        /* Last Page */
        const last = Math.ceil(parseInt(total) / parseInt(size))

        /* Pages */
        const pages = this.generate(last)

        /* Range Of The Current Page */
        const from = size * (parseInt(page) - 1) + 1
        const to = Math.min(size * parseInt(page), parseInt(total))

        return (
            <div className="pagination--box">

                <div className="pagination">

                    {/* Previous */}
                    {this._arrow("prev", last)}

                    {/* Pages */}
                    {pages.map((number, index) => {

                        /* Dots */
                        if (number === DOTS) {
                            return <div className="pagination--dots" key={`${index}`}>{DOTS}</div>
                        }

                        return (
                            <div onClick={() => this.change(number, last)}
                                className={`pagination--item ${parseInt(page) === parseInt(number) ? "active" : ""}`}
                                key={`${index}`}>
                                {number}
                            </div>
                        )
                    })}

                    {/* Next */}
                    {this._arrow("next", last)}

                </div>

                {/* Counter */}
                <div className="pagination--info">
                    <span className="first">{t("pagination.showing")}</span>
                    <b>{from} - {to}</b>
                    <span>{t("pagination.of")} {total}</span>
                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Pagination)
